// extracted by mini-css-extract-plugin
module.exports = {"footer_landingpage":"style_footer_landingpage__7sMsb","footer_detail":"style_footer_detail__3myez","button":"style_button___GWHN","copyright":"style_copyright__MuopX"};